<canvas id="{{id}}" width="{{width}}" height="{{height}}" class="chart" role="img"></canvas>